import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m9.724 6-1.89 8.726-.111-1.056q.834 0 1.39.556.555.5.555 1.278t-.556 1.334q-.5.5-1.278.5-.833 0-1.334-.556-.5-.555-.5-1.278v-.611q.056-.279.111-.612l.222-.778L8.334 6zm7.78 0-1.889 8.726-.111-1.056q.834 0 1.39.556.555.5.555 1.278t-.556 1.334q-.5.5-1.278.5-.834 0-1.334-.556-.5-.555-.5-1.278v-.611q.056-.279.111-.612l.223-.778 2-7.503z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }